const mesesTraducao: { [key: string]: string } = {
    "Jan": "Jan",
    "Feb": "Fev",
    "Mar": "Mar",
    "Apr": "Abr",
    "May": "Mai",
    "Jun": "Jun",
    "Jul": "Jul",
    "Aug": "Ago",
    "Sep": "Set",
    "Oct": "Out",
    "Nov": "Nov",
    "Dec": "Dez"
};

const traduzirMes = (mesEN: string): string => {
    return mesesTraducao[mesEN] || mesEN;
};

export const traduzirIntervaloCronograma = (intervalosCronograma: any[]): any[] => {
    return intervalosCronograma.map(intervalo => {
        const [mesEN, ano] = intervalo.intervalo_execucoes.split('/');
        const mesPT = traduzirMes(mesEN);
        const intervaloExecucoesPT = `${mesPT}/${ano}`;
        return { ...intervalo, intervalo_execucoes: intervaloExecucoesPT };
    });
};
